import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const CustomFormsLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    customFormDetails: LazyLoadedStates 
}> ({
    base: {
        name: 'authenticated.user-summary.custom-forms',
        url: '/custom-forms',
        abstract: true
    },
    customFormDetails: {
        name: 'authenticated.user-summary.custom-forms.details',
        url: '/details/:userId/:observationId',
    }
}, () => import('src/app/observations/custom-forms/custom-forms.module')
    .then((result: { CustomFormsModule: any }) => result.CustomFormsModule)
);
